import React from 'react';

const ActionIcon = ({ type, size = 32, ...props }) => {
  const viewIcon = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        fill="white"
      />
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        stroke="currentColor"
      />
      <path
        d="M16 12.3333C18.5266 12.3333 20.78 13.7533 21.88 16C20.78 18.2467 18.5266 19.6667 16 19.6667C13.4733 19.6667 11.22 18.2467 10.12 16C11.22 13.7533 13.4733 12.3333 16 12.3333ZM16 11C12.6666 11 9.81996 13.0733 8.66663 16C9.81996 18.9267 12.6666 21 16 21C19.3333 21 22.18 18.9267 23.3333 16C22.18 13.0733 19.3333 11 16 11ZM16 14.3333C16.92 14.3333 17.6666 15.08 17.6666 16C17.6666 16.92 16.92 17.6667 16 17.6667C15.08 17.6667 14.3333 16.92 14.3333 16C14.3333 15.08 15.08 14.3333 16 14.3333ZM16 13C14.3466 13 13 14.3467 13 16C13 17.6533 14.3466 19 16 19C17.6533 19 19 17.6533 19 16C19 14.3467 17.6533 13 16 13Z"
        fill="currentColor"
      />
    </svg>
  );

  const editIcon = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        fill="white"
      />
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        stroke="currentColor"
      />
      <path
        d="M17.1647 21.6284H21.9997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.52 10.5299C17.0371 9.91186 17.9667 9.82124 18.5975 10.3278C18.6324 10.3553 19.753 11.2259 19.753 11.2259C20.446 11.6448 20.6613 12.5354 20.2329 13.2151C20.2102 13.2515 13.8746 21.1763 13.8746 21.1763C13.6639 21.4393 13.3439 21.5945 13.0019 21.5982L10.5757 21.6287L10.029 19.3149C9.95244 18.9895 10.029 18.6478 10.2398 18.3849L16.52 10.5299Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.347 12.0005L18.9819 14.7919"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const deleteIcon = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        fill="white"
      />
      <path
        d="M6 0.5H26C29.0376 0.5 31.5 2.96243 31.5 6V26C31.5 29.0376 29.0376 31.5 26 31.5H6C2.96243 31.5 0.5 29.0376 0.5 26V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
        stroke="currentColor"
      />
      <path
        d="M17.7357 10.8028L18.2594 11.945H19.9486C20.4679 11.945 20.889 12.3661 20.889 12.8855V13.5819C20.889 13.937 20.6011 14.2249 20.2461 14.2249H11.4334C11.0783 14.2249 10.7904 13.937 10.7904 13.5819V12.8855C10.7904 12.3661 11.2114 11.945 11.7308 11.945H13.4201L13.9437 10.8028C14.1009 10.46 14.4434 10.2402 14.8205 10.2402H16.859C17.2361 10.2402 17.5785 10.46 17.7357 10.8028Z"
        stroke="currentColor"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.904 14.2725V19.8313C19.904 20.8967 19.0511 21.7603 17.999 21.7603H13.681C12.6289 21.7603 11.776 20.8967 11.776 19.8313V14.2725"
        stroke="currentColor"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7584 16.5225V19.4078M16.9219 16.5225V19.4078"
        stroke="currentColor"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  switch (type) {
    case 'view':
      return viewIcon;
    case 'edit':
      return editIcon;
    case 'delete':
      return deleteIcon;
    default:
      return null;
  }
};

export default ActionIcon;
